import numeral from 'numeral'

import { isEmpty, isString } from './string'

export function formatCurrency(price?: number, cents = false, currencyPrefix = '$') {
  if (price == null) {
    return ''
  }

  const format = cents ? '0,0.00' : '0,0'
  return `${currencyPrefix}${numeral(price).format(format)}`
}

export function parseCurrency(value?: unknown): number | undefined {
  if (value == null || (isString(value) && isEmpty(value))) {
    return undefined
  }

  const parsed = numeral(value).value()
  return typeof parsed === 'number' && !Number.isNaN(parsed) ? parsed : undefined
}
